import React, { useEffect } from "react";
import UserHeader from "../../Component/UserHeader";
import UserSidebar from "../../Component/UserSidebar";
import StudentSignup from "./UpdateProfileStep13";
import PropTypes from "prop-types";


  function SidebarRemoveClass() {
    document.getElementById("OnscrollBody").classList.remove("show_sidebar");
  }
const UpdateProfile2 = (props) => {

  useEffect(() => {
    document.title = props?.title
  }, [props])

  return (
    <div>
      <UserHeader />
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner">
          <h2 className="page_heading mb-3">Complete/ Edit Profile</h2>

          <div className="box shadow bg-white p-md-5">
            <div className="studentformdashboard pt-md-4">
              <StudentSignup type='profile' />

            </div>
          </div>
        </div>
      </div>
     <input
  type="button"
  className="sidebar_overlay"
  onClick={SidebarRemoveClass}
  aria-label="Close sidebar overlay"
/>
    </div>
  );
};
UpdateProfile2.propTypes = {
  title: PropTypes.string,
};


export default UpdateProfile2
